import React from 'react';
import { createStyles } from 'components/group-info/GroupProfile/styles';
import { observer } from 'mobx-react-lite';
import GroupProfileContent from 'components/common/group/content/GroupProfileContent';

const GroupProfile = observer((): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={classes.pageContentWrapper}>
      <header className={classes.pageHeader}>
        <h2 className={classes.title}>Group Profile</h2>
        <p className={classes.subtitle}>All information and business for a group</p>
      </header>
      <GroupProfileContent />
    </div>
  );
});

export default GroupProfile;
